var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',_vm._g(_vm._b({directives:[{name:"paste",rawName:"v-paste",value:('input'),expression:"'input'"}],attrs:{"options":_vm.options},on:{"paste":_vm.onPaste},model:{value:(_vm.proxyValue),callback:function ($$v) {_vm.proxyValue=$$v},expression:"proxyValue"}},'base-select',_vm.proxyProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }